import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled, { css } from "styled-components";
import { carritoController } from "utils/carritoControllers";
import { getDecimals, getPriceWithoutDecimals } from "utils/mathFunctions";
import { findBiggerEspSize } from "utils/randomFunctions";
import { MainButton } from "components/styles/smallComponents";
import { PromoDisplay } from "./SingleCartItem";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { FiTruck } from "react-icons/fi";
import { RiArrowGoBackFill } from "react-icons/ri";
import { HASH_LINKS } from "Theconstants";
import { HashLink } from "react-router-hash-link";
import { useAppDispatch, useAppSelector } from "context/store";
import { FILTER_KEYS } from "components/Filters/data";

const TamañoSelectorResponsive = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px;
`;
const TamañoIndividualResponsive = styled.div<{ active: boolean }>`
  border: 2px solid ${(props) => props.theme.body};
  cursor: pointer;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(var(--fontSmall) - 0.2rem);
  transition: 0.3s;
  padding: 5px;
  /* ---------- */
  color: ${(props) => props.active && props.theme.secondaryBody};
  background-color: ${(props) => props.active && props.theme.text};
`;
/* ---------------------------------------- */
const ImgOverlay = styled.div`
  background-color: rgba(365, 365, 365, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: 0.3s;
`;
const Container = styled.div`
  box-shadow: 11px 17px 22px -17px ${(props) => props.theme.shadow};

  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.border};
  color: black;
  align-self: stretch;
  background-color: #edd5d5;

  padding: 10px 0;
  border-radius: initial;
  font-size: var(--fontMed);
`;

const Info = styled.div`
  padding: 0 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: calc(var(--fontMed) + 0.1rem);

  &:hover ${ImgOverlay} {
    opacity: 1;
  }
`;
/* -----------------TEXTO DE ARRIBA PREVIO A LA IMG--- */
const Header = styled(HashLink)`
  flex: 1;

  font-size: var(--fontSmall);
`;
const Marca = styled.div`
  text-transform: uppercase;
`;
const TituloNombre = styled.div`
  font-weight: bold;
  margin-top: 10px;
  letter-spacing: 1px;
`;
/* -------------------------------------- */
const containHeight = "500px";
const ImgContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 350px;
  margin: 20px 0;
  cursor: pointer;
  /* lo pongo blanco p/q en object-fit contain no se vea el background gris y la img centrada 
  IMPORTANTE: si la img tiene otro color de fondo q no sea blanco va a quedar feo igual*/
  background-color: white;
  @media (max-width: 720px) {
    max-height: 250px;
  }
  @media (max-width: ${containHeight}) {
    max-height: 120px;
  }
`;

const Img = styled.img`
  width: 100%;
  display: block;
  height: 100%;
  object-fit: cover;
  @media (max-width: ${containHeight}) {
    object-fit: contain;
  }
`;

const FlexIt = styled.div<{ cartAndSingleProd?: boolean }>`
  display: flex;
  gap: 10px;

  /* ----------tanto fw como fz aplican a Preciopromo y Precio x default */
  /* si dsp Precio esta en promo le hago un override */

  font-weight: bold;
  /* ----------------------------- */

  font-size: var(--fontSmall);
  flex-direction: ${(props) => (props.cartAndSingleProd ? "column" : "row")};
  align-items: ${(props) =>
    props.cartAndSingleProd ? "flex-start" : "center"};
`;
const Precio = styled.span<{ promocion: ProdCarrito["promocion"] }>`
  font-weight: ${(props) => props.promocion && "300"};
  color: ${(props) => props.promocion && props.theme.grey};
  text-decoration: ${(props) => props.promocion && "line-through"};
  font-size: ${(props) => props.promocion && css`calc(var(--fontMed) - .2rem)`};
  @media (max-width: 500px) {
    font-size: ${(props) => props.promocion && css`var(--fontSmall)`};
  }
`;
const PrecioPromo = styled.div``;
const Decimals = styled.span`
  vertical-align: top;
  font-size: calc(var(--fontSmall) - 0.4rem);
`;
const Envio = styled.div`
  cursor: pointer;
  letter-spacing: 1px;
  /* ------------- */
  color: var(--mainGreen);
  padding: 10px;
  /*   padding: 10px 0 0 10px; */
  margin-top: 10px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 10px;
  text-transform: uppercase;

  font-size: calc(var(--fontSmall) + 0.05rem);
  @media (max-width: 600px) {
    font-size: calc(var(--fontSmall) - 0.05rem);
    margin-top: 0px;
  }
  /* truck logo and other logo */
  & > * {
    font-size: var(--fontMed);
  }
`;

const Devolucion = styled(Envio)`
  margin: 0;
  padding: 0 0 10px 10px;
  text-transform: capitalize;
`;
const NoStock = styled.div`
  padding: 10px;
  text-align: center;

  color: ${(props) => props.theme.red};

  font-size: calc(var(--fontMed) - 0.2rem);
`;

const BtnAgregar = styled(MainButton)``;
const PromoDifferentColor = styled(PromoDisplay)`
  background-color: var(--mainBlack)
    /*  crimson color q queria sebas era muy feo */;
`;

export const SingleDestacado = (props: IProducto) => {
  //este es el tamaño q el Cliente va a ver/q vamos a mostrar, loopeamos ESP y lo elegimos.
  const [prodSizeShowing, setProdSizeShowing] = useState<IEspecificacion>(); //contiene tamaño, stock, precio, promocion, descuento, _id
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    user: { carrito },
  } = useAppSelector((state) => state);
  const [searchParams] = useSearchParams();
  const { nombre, esp, marca, img, _id } = props; //es el PROD entero, con esp/todos los tamaños
  /*-------------------ADD TO CART ------------------------*/
  /*Si mirás abajo en el MainButton, a la addCart fn le paso las props, x eso dsp uso el prodSizeShowing _id p/buscar el producto q el cliente quiere efectivamente agregar al carrito*/
  function addCart(item: IProducto) {
    if (!prodSizeShowing) return;
    const final = carritoController.processMyEspObject(item, prodSizeShowing);
    /* si no agrego 4to parameter a addCart, defaultea a 1 unidad p/agregar */
    carritoController.addCart(final, dispatch, carrito);
  }
  //CON ESTE USEEFFECT DECIDO Q TAMAñO MOSTRAR, por lo gral el de + tamaño (por eso biggerProd), siempre y cuando HAYA STOCK
  //Aca EN PPIO no es necesario modificar NADA P/ la PROMOCION. Pero creo q para el filtro en searchParams sí voy a tener q agregar una pequeña modificacion
  //21/5/22: creo q si en searchParams hay una promo activa, tendría q mostrar el prod/tamaño q está en PROMO, tiene prioridad
  useEffect(() => {
    if (esp.length > 0) {
      if (searchParams.get(FILTER_KEYS.PROMO)) {
        return setProdSizeShowing(esp.find((i) => i.promocion));
      }
      /* esta funcion la pasé a utils xq la usa tmb la SingleProdPage */
      setProdSizeShowing(findBiggerEspSize(esp));
    }
  }, [esp, searchParams]);

  return (
    <Container>
      <Info>
        <Header
          to={`${FRONTEND_ENDPOINTS.dynamicSingleProduct(_id)}#${
            HASH_LINKS.TOP
          }`}
        >
          <Marca>{marca} 🔥🔥</Marca>
          <TituloNombre>
            {nombre} {prodSizeShowing?.tamaño}ml
          </TituloNombre>
        </Header>
        <ImgContainer
          onClick={() =>
            navigate(
              `${FRONTEND_ENDPOINTS.dynamicSingleProduct(_id)}#${
                HASH_LINKS.TOP
              }`
            )
          }
        >
          {prodSizeShowing?.promocion && (
            <>
              <PromoDifferentColor>
                {prodSizeShowing.descuento}% OFF
              </PromoDifferentColor>
            </>
          )}
          <ImgOverlay />
          <Img src={img}></Img>
        </ImgContainer>
        {/* ACA TENGO Q CHEQUEAR SI HAY O NO PROMOCION */}
        {!!prodSizeShowing && <PriceComponent {...prodSizeShowing} cart />}
      </Info>
      <TamañoSelectorResponsive>
        {esp.length > 0 &&
          esp.map((i) => (
            <TamañoIndividualResponsive
              //CREO q no es necesario tampoco aca realizar cambios
              onClick={(e) => {
                e.stopPropagation();
                setProdSizeShowing(i);
              }}
              active={i?.tamaño === prodSizeShowing?.tamaño}
              key={i._id}
            >
              {i.tamaño}ml
            </TamañoIndividualResponsive>
          ))}
      </TamañoSelectorResponsive>
      {prodSizeShowing?.stock ? ( //CALCULO Q EN ADDCART PONGO EL PRODSIZESHOWING
        <>
          <div
            onClick={() =>
              navigate(
                `${FRONTEND_ENDPOINTS.dynamicSingleProduct(_id)}#${
                  HASH_LINKS.TOP
                }`,
              )
            }
          >
            <Envio>
              Envío full <FiTruck />{" "}
            </Envio>
            <Devolucion>
              Devolución gratis {/* <GiReturnArrow /> */}
              <RiArrowGoBackFill />
            </Devolucion>
          </div>
          <BtnAgregar
            fn={() => {
              addCart(props);
            }}
          >
            Comprar
          </BtnAgregar>
        </>
      ) : (
        <>
          <br />
          <NoStock>No hay stock</NoStock>
        </>
      )}
    </Container>
  );
};

//todo: VER EL CART Q SOLO HACE FLEX, harìa refactor
//TODO: ver xq hay otro componente en SingleProducto con el mismo nombre
export function PriceComponent(
  props: Pick<ProdCarrito, "promocion" | "precio" | "descuento" | "stock"> & {
    cart?: boolean;
  }
) {
  if (!props?.stock) {
    return <br />;
  }
  return (
    <FlexIt cartAndSingleProd={props?.cart}>
      {props?.promocion && (
        <PrecioPromo>
          $ {getPriceWithoutDecimals(props).toLocaleString()}
          <Decimals>{getDecimals(props)}</Decimals>🔥🔥
        </PrecioPromo>
      )}
      <Precio promocion={props?.promocion}>
        $ {props?.precio && Math.floor(props?.precio)}
        {/* Paso true como 2nd parametro, p/q me mande full price, regardless of whether there is a promo */}
        <Decimals>{props?.precio && getDecimals(props, true)}</Decimals>
        {!props.promocion && "🔥🔥"}
      </Precio>
    </FlexIt>
  );
}
